import React, { useState } from 'react';
import HeroSection from './components/HeroSection';
import BusinessGrowthSection from './components/BusinessGrowthSection';
import ServicesCardsSection from './components/ServicesCardsSection';
import PartnersTrustSection from './components/PartnersTrustSection';
import ResultsInActionSection from './components/ResultsInActionSection';
import VisionImpactSection from './components/VisionImpactSection';
import CallToActionBanner from './components/CallToActionBanner';
import EntrepreneurialBooksSection from './components/EntrepreneurialBooksSection';
import FreeWorkshopSection from './components/FreeWorkshopSection';
import HireMeToSpeakSection from './components/HireMeToSpeakSection';
import Footer from './components/Footer';
import { ThemeProvider } from './components/ThemeProvider';
import { defaultTheme } from './config/theme';

function App() {
  const [autoOpenModal, setAutoOpenModal] = useState(false);

  // Event handlers for buttons
  const handlePrimaryButtonClick = () => {
    // Scroll to the "Let's Co-Create" section
    const hireSection = document.getElementById('hire');
    if (hireSection) {
      hireSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Trigger modal to open after scroll
      setAutoOpenModal(true);
      // Reset after a delay to allow re-triggering if needed
      setTimeout(() => {
        setAutoOpenModal(false);
      }, 2000);
    }
  };

  const handleSecondaryButtonClick = () => {
    console.log('Secondary button clicked - Get More Leads');
    // Add your lead generation logic here
  };

  const handleFreeTrainingClick = () => {
    // Scroll to the contact section
    const contactSection = document.getElementById('hire');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Trigger modal to open after scroll
      setAutoOpenModal(true);
      // Reset after a delay to allow re-triggering if needed
      setTimeout(() => {
        setAutoOpenModal(false);
      }, 2000);
    }
  };

  const handleNavItemClick = (item) => {
    console.log(`Navigation clicked: ${item}`);
    // Add your navigation logic here
  };

  const handleFindOutMoreClick = () => {
    console.log('Find Out More clicked');
    // Add your find out more logic here
  };

  const handleRegisterClick = () => {
    console.log('Register clicked');
    // Add your register logic here
  };

  const handleAcceleratorsClick = () => {
    console.log('Our Accelerators clicked');
    // Add your accelerators logic here
  };

  const handleLeadsClick = () => {
    console.log('Get More Leads clicked');
    // Add your leads logic here
  };

  const handleKPIClick = () => {
    console.log('KPI Score clicked');
    // Add your KPI logic here
  };

  const handleBooksClick = () => {
    console.log('Books & Resources clicked');
    // Add your books logic here
  };

  const handleCoachingClick = () => {
    console.log('Coaching & Mentoring clicked');
    // Add your coaching logic here
  };

  const handleEntrepreneurRevolutionClick = () => {
    console.log('Entrepreneur Revolution clicked');
    // Add your book logic here
  };

  const handleKeyPersonClick = () => {
    console.log('Key Person of Influence clicked');
    // Add your book logic here
  };

  const handleOversubscribedClick = () => {
    console.log('Oversubscribed clicked');
    // Add your book logic here
  };

  const handle24AssetsClick = () => {
    console.log('24Assets clicked');
    // Add your book logic here
  };

  const handleHireMeClick = () => {
    console.log('Hire Me To Speak clicked');
    // Add your hire me logic here
  };

  const navigationItems = [
    { label: 'Services', target: 'services' },
    { label: 'Partners', target: 'trusted-partners' },
    { label: 'Case Studies', target: 'results' },
    { label: 'Vision', target: 'vision-impact' },
    { label: 'Get in Touch', target: 'cta-banner' },
  ];

  return (
    <ThemeProvider>
      <div className="App">
        {/* Hero Section */}
        <HeroSection
          name={defaultTheme.content.name}
          tagline={defaultTheme.content.tagline}
          mainHeading={defaultTheme.content.mainHeading}
          primaryButtonText={defaultTheme.content.primaryButtonText}
          secondaryButtonText={defaultTheme.content.secondaryButtonText}
          freeTrainingText={defaultTheme.content.freeTrainingText}
          imageSrc={defaultTheme.images.heroImage}
          navigationItems={navigationItems}
          onPrimaryButtonClick={handlePrimaryButtonClick}
          onSecondaryButtonClick={handleSecondaryButtonClick}
          onFreeTrainingClick={handleFreeTrainingClick}
          onNavItemClick={handleNavItemClick}
        />

        {/* Business Growth Section */}
        <section>
          <BusinessGrowthSection
            onButtonClick={handleFindOutMoreClick}
          />
        </section>

        {/* Divider */}
        <div className="w-full flex justify-center py-4">
          <div 
            className="h-1 max-w-4xl w-full"
            style={{
              background: 'linear-gradient(to right, transparent 0%, #D1D5DB 15%, #D1D5DB 85%, transparent 100%)'
            }}
          ></div>
        </div>

        {/* Services Cards Section */}
        <section id="services">
          <ServicesCardsSection
          cards={[
            {
              title: "Coaching",
              iconKey: "Coaching & Mentoring",
              buttonText: "Learn More",
              onButtonClick: handleCoachingClick
            },
            {
              title: "Investment readiness",
              iconKey: "KPI Score",
              buttonText: "Learn More",
              onButtonClick: handleKPIClick
            },
            {
              title: "Business diagnosis",
              iconKey: "Books & Resources",
              buttonText: "Learn More",
              onButtonClick: handleBooksClick
            },
            {
              title: "Due diligence",
              iconKey: "Our Accelerators",
              buttonText: "Learn More",
              onButtonClick: handleAcceleratorsClick
            },
            {
              title: "Training / capacity building",
              iconKey: "Free Live Training",
              buttonText: "Learn More",
              onButtonClick: handleRegisterClick
            },
            {
              title: "Entrepreneurship Program design",
              iconKey: "Our Accelerators",
              buttonText: "Learn More",
              onButtonClick: handleAcceleratorsClick
            }
          ]}
        />
        </section>

        {/* Divider */}
        <div className="w-full flex justify-center py-4">
          <div 
            className="h-1 max-w-4xl w-full"
            style={{
              background: 'linear-gradient(to right, transparent 0%, #D1D5DB 15%, #D1D5DB 85%, transparent 100%)'
            }}
          ></div>
        </div>

        {/* Partners Trust Section */}
        <section id="trusted-partners">
          <PartnersTrustSection />
        </section>

        {/* Divider */}
        <div className="w-full flex justify-center py-4">
          <div 
            className="h-1 max-w-4xl w-full"
            style={{
              background: 'linear-gradient(to right, transparent 0%, #D1D5DB 15%, #D1D5DB 85%, transparent 100%)'
            }}
          ></div>
        </div>

        {/* Results in Action Section */}
        <section id="results">
          <ResultsInActionSection
            title="Results in Action"
            subtitle="Real outcomes delivered by Yomuma Likessa and team"
            achievements={[
            {
              heading: 'EdTech Fellowship Program',
              body: '3 fellows coached → all secured follow-on funding within 6 months.'
            },
            {
              heading: 'Accelerator Partnership',
              body: 'Delivered founder training & diagnostics for NGO-funded program—20+ startups achieved product-market fit and investor readiness.'
            },
            {
              heading: 'Donor-Funded Incubation',
              body: 'Co-designed program framework for MSME growth → replicated by regional partners in Rwanda and Kenya.'
            }
          ]}
            ctaText="Get the Full Case Study Pack"
            onCtaClick={() => console.log('Get the Full Case Study Pack clicked')}
          />
        </section>

        {/* Divider */}
        <div className="w-full flex justify-center py-4">
          <div 
            className="h-1 max-w-4xl w-full"
            style={{
              background: 'linear-gradient(to right, transparent 0%, #D1D5DB 15%, #D1D5DB 85%, transparent 100%)'
            }}
          ></div>
        </div>

        {/* Vision & Impact Section */}
        <section id="vision-impact">
          <VisionImpactSection
            heading="Vision & Impact"
            mission="Our mission is to make Ethiopia —and East Africa— a hub for entrepreneurial excellence. By strengthening each coaching session and each program we touch, we build ecosystems that create jobs, innovation, and hope."
            author="Yomuma Likessa Daba, Founder & Ecosystem Architect"
          />
        </section>

        {/* Divider */}
        <div className="w-full flex justify-center py-4">
          <div 
            className="h-1 max-w-4xl w-full"
            style={{
              background: 'linear-gradient(to right, transparent 0%, #D1D5DB 15%, #D1D5DB 85%, transparent 100%)'
            }}
          ></div>
        </div>

        {/* Call-to-Action Banner */}
        <section id="cta-banner">
          <CallToActionBanner
            headline="Your founders deserve world-class support."
            subtext="Let's co-design your next cohort so every founder leaves with clarity, traction, and investor-ready momentum."
            primaryText="Book Strategic Call"
          />
        </section>

        {/* Divider */}
        <div className="w-full flex justify-center py-4">
          <div 
            className="h-1 max-w-4xl w-full"
            style={{
              background: 'linear-gradient(to right, transparent 0%, #D1D5DB 15%, #D1D5DB 85%, transparent 100%)'
            }}
          ></div>
        </div>

        {/* Entrepreneurial Books Section */}
        {/* <EntrepreneurialBooksSection
          books={[
            {
              title: "ENTREPRENEUR REVOLUTION",
              imageSrc: "/Book1.webp",
              buttonText: "Read More",
              onButtonClick: handleEntrepreneurRevolutionClick
            },
            {
              title: "KEY PERSON OF INFLUENCE",
              imageSrc: "/Book1.webp",
              buttonText: "Read More",
              onButtonClick: handleKeyPersonClick
            },
            {
              title: "OVERSUBSCRIBED",
              imageSrc: "/Book1.webp",
              buttonText: "Read More",
              onButtonClick: handleOversubscribedClick
            },
            {
              title: "24ASSETS",
              imageSrc: "/Book1.webp",
              buttonText: "Read More",
              onButtonClick: handle24AssetsClick
            }
          ]}
        /> */}

        {/* Divider */}
        <div className="w-full flex justify-center py-4">
          <div 
            className="h-1 max-w-4xl w-full"
            style={{
              background: 'linear-gradient(to right, transparent 0%, #D1D5DB 15%, #D1D5DB 85%, transparent 100%)'
            }}
          ></div>
        </div>

        {/* Free Live Workshop Section */}
        {/* <FreeWorkshopSection
          onButtonClick={() => console.log('Book Onto Workshop clicked')}
        /> */}

        {/* Divider */}
        {/* <div className="w-full flex justify-center py-4">
          <div 
            className="h-1 max-w-4xl w-full"
            style={{
              background: 'linear-gradient(to right, transparent 0%, #D1D5DB 15%, #D1D5DB 85%, transparent 100%)'
            }}
          ></div>
        </div> */}

        {/* Hire Me To Speak Section */}
        <section id="hire">
          <HireMeToSpeakSection
            onButtonClick={handleHireMeClick}
            autoOpenModal={autoOpenModal}
          />
        </section>

        {/* Divider */}
        <div className="w-full flex justify-center py-4">
          <div 
            className="h-1 max-w-4xl w-full"
            style={{
              background: 'linear-gradient(to right, transparent 0%, #D1D5DB 15%, #D1D5DB 85%, transparent 100%)'
            }}
          ></div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
